import { IconButton, Badge, Snackbar, Slide, CircularProgress, Button, Popover, Typography, CardActionArea, Card, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNavigate } from "react-router";
import { axiosFetch } from '../../../utils/AxiosFetch';
import CloseIcon from '@mui/icons-material/Close';
import Box from "@mui/material/Box";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import NotificationMessage from './NotificationMessage';
import { useDispatch, useSelector } from "react-redux";
import { notification_list } from '../../../redux/actions/notification.action';
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";

function NotificationHome() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [notificationList, setNotificationList] = useState([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const [openNotify, setOpenNotify] = useState(false);
    const list = useSelector(state => state.fetchNotificationList_Reducer.notificationList);
    const [loading, setLoading] = useState(false);
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosenote = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        dispatch(notification_list())
        setInterval(() =>
            checkNotification()
            , 10000);
    }, [])

    useEffect(() => {
        setNotificationCount(list.length)
        setNotificationList(list)
    }, [list])

    function SlideTransition(props) {
        return <Slide {...props} direction="left" />;
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenNotify(false);
    };

    const checkNotification = () => {
        if(localStorage.getItem('argus_user')){
            axiosFetch({
            method: 'GET',
            url: `/Notifications/checker`,
            })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data === true) {
                        setOpenNotify(true);
                        dispatch(notification_list())
                    }
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(error => {
                console.log(error);
            });}
    }

    const notificationsLabel = (count) => {
        if (count === 0) {
            return 'no notifications';
        }
        if (count > 99) {
            return 'more than 99 notifications';
        }
        return `${count} notifications`;
    }
    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const handleRead = () => {
        var req = {
            "id": 0,
            "isMarkAll": true
        }
        setLoading(true);
        axiosFetch({
            method: 'POST',
            url: `/Notifications/isread`,
            requestConfig: req,
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(notification_list())
                    setLoading(false);

                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                    setLoading(false);

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    const Content = () => (
        <Box
            sx={{ width: 400, p: 2, backgroundColor: "#f8f8f8" }}
            role="presentation"
            className="notification-box"
        >
            <Typography className="filter-heading" variant="subtitle1" gutterBottom sx={{ fontWeight: "bold" }}>
                Notifications({notificationCount})<span style={{ float: "right", cursor: "pointer" }}><CloseIcon onClick={handleClosenote} /></span>
            </Typography>
            <Divider sx={{ marginBottom: "15px" }} />
            {notificationList.length !== 0 ?
                <>{loading ?
                    <CircularProgress sx={{ marginLeft: 40 }} size="1rem" /> :
                    <Typography gutterBottom
                        sx={{ fontWeight: "bold", fontSize: "13px" }}
                        onClick={() => handleRead()}
                        className="clear-all-link">
                        Mark all as read
                    </Typography>}
                </> :
                <Typography>No new notifications</Typography>
            }
            <br />
            <div>
                {
                    notificationList && notificationList.length > 0 && notificationList.map((message) => {
                        return (
                            <NotificationMessage notification={message} />

                        )
                    })
                }

            </div>
        </Box>
    );
    return (
        <>
            <IconButton aria-describedby={id} sx={{ color: "white" }} aria-label={notificationsLabel(100)} onClick={handleClick}>
                <Badge badgeContent={notificationCount} color="secondary">
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <Snackbar
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
                open={openNotify}
                onClose={handleClose}
                TransitionComponent={SlideTransition}
                message="You have got new notification(s)"
                action={action}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClosenote}
                anchorReference="anchorPosition"
                anchorPosition={{ top: 80, left: 3000987 }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Content />
                {/* <Typography sx={{ p: 2, width: 400 }}>The content of the Popover.</Typography> */}
            </Popover>
        </>
    )
}
export default NotificationHome;